var exports = {
  "R": "xa15a2ab7--93bd54--hidden",
};

module.exports = exports;
